module.exports = __webpack_public_path__ + "media/images/front/team_m-a3c3d124262da12372fb5f181f449666.webp";